import { apiUri } from "../../../config";
import axios from "axios";
import { padCalendar } from "../../../util";

export const LOAD_CASES = 'LOAD_CASES';


const receivedPageOfCases = (cases, page) => {
    const convertedCases = cases.content.map(c => {
        c.dateFiled = padCalendar(c.dateFiled);
        c.classPeriodStart = padCalendar(c.classPeriodStart);
        c.classPeriodEnd = padCalendar(c.classPeriodEnd);
        return {
            fillingName: c.commissionName,
            classPeriodStart: c.classPeriodStart,
            classPeriodEnd: c.classPeriodEnd,
            ticker: c.symbol,
            id: c.id,
            caseId: c.caseId,
            status: c.status,
            docketId: '',
            sicCode: c.sicCode,
            enabled: c.enabled,
            identifier: c.identifier,
            caseRuleTypeId: c.caseRuleTypeId,
            caseRuleType: c.caseRuleType,
            caseFile: c.caseFile,
            market: c.market,
        }
    }
    );
    return ({
        type: LOAD_CASES,
        cases: convertedCases,
        totalCases: cases.total,
        totalPages: cases.totalPages,
        currentPage: page
    })
};


export const searchData = (page) => {
   
    let pageNo = page;
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    var search = '';
    if (searchData) {
        search = searchData;
    }
    return dispatch => {

        axios.get(apiUri + "/commissions/commissionsList?page=" + pageNo + "&search=" + search + "&sortField=&order=")
            .then(json => dispatch(receivedPageOfCases(json.data, page)))
            .catch(err => { console.log(err) })
    }
};
export const searchSortData = (page, sortKey, sortOrder) => {
    
    let pageNo = page;
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    var search = '';
    if (searchData) {
        search = searchData;
    }
    return dispatch => {

        axios.get(apiUri + "/commissions/commissionsList?page=" + pageNo + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
            .then(json => dispatch(receivedPageOfCases(json.data, page)))
            .catch(err => { console.log(err) })
    }
};


export const requestPageOfCases = (page, sortKey, sortOrder) => {
    
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    let sortData = JSON.parse(localStorage.getItem("sortParams"));

    var search = '';
    sortKey = '';
    sortOrder = '';
    if (searchData) {
        search = searchData;
    }
    if (sortData) {
        sortKey = sortData.sortValue;
        sortOrder = sortData.sortOrder;
    }
    return dispatch => {

        axios.get(apiUri + "/commissions/commissionsList?page=" + page + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
            .then(json => {
                dispatch(receivedPageOfCases(json.data, page))
            })
            .catch(err => { console.log(err) })
    }
};

export const requestPageOfCommission = (page, sortKey, sortOrder) => {
    let searchData = JSON.parse(localStorage.getItem("searchValue"));
    let sortData = JSON.parse(localStorage.getItem("sortParams"));

    var search = '';
    sortKey = '';
    sortOrder = '';
    if (searchData) {
        search = searchData;
    }
    if (sortData) {
        sortKey = sortData.sortValue;
        sortOrder = sortData.sortOrder;
    }
    return dispatch => {

        axios.get(apiUri + "/commissions/commissionsList?page=" + page + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
            .then(json => dispatch(receivedPageOfCases(json.data, page)))
            .catch(err => { console.log(err) })
    }
};


// WEBPACK FOOTER //
// ./src/components/Admin/store1/action.js